import { useMutation, useQueryClient } from 'react-query';

import QueryKeys from '@constants/query-keys';
import { MutationConfig } from '@helpers';
import { ApiClientEnterprise } from '@helpers/apiClients';
import { API_LINK_MANAGEMENT_URL } from '@organisms/Tables/Enterprise/LinksManagementTable/constants';

export const uploadCSVLink = ({ data, organizationId }: { data: File; organizationId: string }) => {
  const formData = new FormData();
  formData.append('file', data);
  return ApiClientEnterprise.post(
    `${API_LINK_MANAGEMENT_URL}${organizationId}/links/csv`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  );
};

type UseUploadCSVLink = {
  mutationConfig?: MutationConfig<typeof uploadCSVLink>;
};

export const useUploadCSVLink = ({ mutationConfig }: UseUploadCSVLink = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: QueryKeys.enterpriseLinksManagement,
      });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: uploadCSVLink,
  });
};
